﻿/*
 * Purpose: Render a presentational status chip used in AuthForm for validation indicators.
 * Boundary: Pure UI; no state or side effects; style determined from props.
 * Invariants:
 * - ASCII only; no Unicode symbols.
 * - Color and icon reflect validation state.
 */

// Component Chip:
// Displays a styled status chip with optional checkmark
export default function Chip({ ok, children, muted, warnWhenMissing }) {
    // Constants - base class and variant color sets
    const base = "inline-flex items-center rounded-md px-1.5 py-0.5 md:px-3 md:py-1 ring-1 text-[11px] md:text-[13px]";
    const green = "bg-emerald-900/20 ring-emerald-700/40 text-emerald-300";
    const orange = "bg-orange-900/20 ring-orange-700/40 text-orange-300";
    const grey = "bg-neutral-900 ring-neutral-700 text-neutral-300";

    // Derived Values - select style class based on state flags
    let cls = grey;
    if (muted) cls = grey;                 // Pre-start or inactive
    else if (ok) cls = green;              // Satisfied -> green
    else if (warnWhenMissing) cls = orange; // Missing -> orange

    // Rendering - ASCII checkmark appended when ok=true
    return <span className={`${base} ${cls}`}>{children}{ok ? " ✓" : ""}</span>;
}
